import { ProgressBar } from '@sgme/ui';
import { Layout } from 'components/missed-deal-feedback/components/layout';
import { MissedDealFeedbackReadonlyForm } from 'components/missed-deal-feedback/components/readonly-form';
import { SubmissionStatus } from 'components/missed-deal-feedback/components/submission-status';
import { useAppSelector } from 'hooks/useAppSelector';
import { useProgressTimer } from 'hooks/useProgressTimer';
import { FormIdProps } from 'shared/props';
import {
  getFeedbackSubmissionEstimatedTimeInMilliseconds,
  getFeedbackSubmissionRequestStartDateInMilliseconds,
} from 'state/missed-deal-feeedback/selectors';

export function MissedDealFeedbackSubmissionPending({ formId }: FormIdProps) {
  const { startDateInMilliseconds, estimatedTimeInMilliseconds } = useAppSelector(state => ({
    startDateInMilliseconds: getFeedbackSubmissionRequestStartDateInMilliseconds(state, formId)!,
    estimatedTimeInMilliseconds: getFeedbackSubmissionEstimatedTimeInMilliseconds(state, formId)!,
  }));
  const { progressInPercent } = useProgressTimer(startDateInMilliseconds, estimatedTimeInMilliseconds);
  return (
    <Layout.Wrapper>
      <Layout.Body>
        <MissedDealFeedbackReadonlyForm formId={formId} />
      </Layout.Body>
      <SubmissionStatus textIntlKey="missedDealFeedback.submittingFeedback" />
      <ProgressBar size="md" color="info" value={progressInPercent} />
    </Layout.Wrapper>
  );
}
